// Check if window is defined (so if in the browser or in node.js).
const isBrowser = typeof window !== 'undefined'
const defaultOverflow = 'auto'
export const preventBackgroundScrolling = () => {
  if (!isBrowser)
    return {
      originalBodyPad: 0,
      originalBodyOverflow: defaultOverflow,
      isBodyOverflowing: false,
    }
  const rawPaddingValue = document.body.style.paddingRight || '0'
  // FIXME support for non pixel values (em/rem...)
  const originalBodyPad = parseInt(rawPaddingValue)
  const originalBodyOverflow = document.body.style.overflow || defaultOverflow

  const isBodyOverflowing = document.body.clientWidth < window.innerWidth
  if (isBodyOverflowing) {
    const scrollbarWidth = getScrollbarWidth()
    document.body.style.setProperty('padding-right', `${originalBodyPad + scrollbarWidth}px`, 'important')
    document.body.style.overflow = 'hidden'
  }
  return { originalBodyPad, originalBodyOverflow, isBodyOverflowing }
}

export const restoreBackgroundScrolling = (originalBodyPad: number, originalBodyOverflow: string) => {
  if (!isBrowser) return
  document.body.style.paddingRight = originalBodyPad + 'px'
  document.body.style.overflow = originalBodyOverflow
}

// Credits to David Walsh: https://davidwalsh.name/detect-scrollbar-width
export const getScrollbarWidth = () => {
  if (!isBrowser || process.env.NODE_ENV === 'test') return 16
  const scrollDiv = document.createElement('div')
  scrollDiv.setAttribute('style', 'width: 99px; height: 99px; overflow: scroll; position:absolute; top:-9999px;')
  document.body.appendChild(scrollDiv)
  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
  document.body.removeChild(scrollDiv)
  return scrollbarWidth
}
